import { combineReducers } from "redux";
import questionnaires from "./questionnaires";

export default combineReducers({
  questionnaires,
});
